module.exports = __webpack_public_path__ + "static/img/coze-assistant.5d6757f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coze-assistant.png
// module id = POUD
// module chunks = 115